export default "__VITE_ASSET__0829bbb1__"